import React from 'react';
import FormListItemObjectContainer from '../../components/FormListItemObjectContainer';

const FormObjectInput = ({
  autoFocus,
  component,
  disabled,
  error,
  field,
  hideLabel,
  onChange,
  text,
}) => {
  const FieldComponent = component?.editor;

  if (!FieldComponent) {
    return null;
  }

  return (
    <FormListItemObjectContainer
      error={error}
      field={field}
      hasLabel={component.hasLabel}
      hideLabel={hideLabel}
    >
      <FieldComponent
        autoFocus={autoFocus}
        disabled={disabled}
        error={error}
        field={field}
        onChange={onChange}
        text={text}
      />
    </FormListItemObjectContainer>
  );
};

export default FormObjectInput;
